<div *ngIf="isComponentInitialized">
    <div class="flex-row method-section">
        <div style="align-items: flex-start" class="flex-row align-center width-93">
            <div class="width-3-5-rem" style="padding-left: 0.5rem">
                <img mat-card-image src="/assets/icons8-apri-messaggio.svg" alt="" class="width-3-5-rem" />
            </div>
            <div class="flex-column margin-left-description">
                <div class="flex-row align-center">
                    <span class="font-weight-400" translate>2FA_SETTINGS.EMAIL_MESSAGE</span>
                    <span class="mfa-info">{{ model.Email }}</span>
                    <mat-chip-list aria-label="Fish selection">
                        <mat-chip class="bgBluMagoLight" *ngIf="model.TwoFactorType === 2" selected
                            ><span class="text-chip" translate>2FA_SETTINGS.PREFERRED</span></mat-chip
                        >
                        <mat-chip class="bgGreen" selected><span class="text-chip" translate>2FA_SETTINGS.ENABLED</span></mat-chip>
                    </mat-chip-list>
                </div>
                <span>{{ message_1 }}</span>
            </div>
        </div>
        <div class="flex-row width-7" *ngIf="model.TwoFactorType !== 2">
            <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                <mat-icon class="color-white">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
                <button mat-menu-item *ngIf="model.TwoFactorType !== 2" (click)="save(2)">
                    <span translate>2FA_SETTINGS.SET_METHOD</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div class="flex-row align-center method-section">
        <div class="flex-row">
            <div class="flex-row width-93">
                <div class="width-3-5-rem" style="padding-left: 0.5rem">
                    <img mat-card-image src="/assets/icons8-phone-bubble.svg" alt="" class="width-3-5-rem" />
                </div>
                <div class="flex-column margin-left-description">
                    <div class="flex-row align-center">
                        <span class="font-weight-400" translate>2FA_SETTINGS.SMS</span>
                        <span class="mfa-info" *ngIf="phoneNumberEnabled"
                            ><span translate>2FA_SETTINGS.PHONE_NUMBER</span> {{ copyOfMobilePhoneNr }}</span
                        >
                        <mat-chip-list aria-label="Fish selection">
                            <mat-chip class="bgBluMagoLight" selected *ngIf="model.TwoFactorType === 1"
                                ><span class="text-chip" translate>2FA_SETTINGS.PREFERRED</span></mat-chip
                            >
                            <mat-chip class="bgGreen" selected *ngIf="phoneNumberEnabled"
                                ><span class="text-chip" translate>2FA_SETTINGS.ENABLED</span></mat-chip
                            >
                        </mat-chip-list>
                    </div>
                    <span>{{ message_2 }}</span>
                    <div *ngIf="showSmsSection">
                        <div class="margin-top-1-25rem">
                            <div class="width-18-75-rem">
                                <form #f="ngForm" [formGroup]="phoneForm">
                                    <ngx-intl-tel-input
                                        [preferredCountries]="preferredCountries"
                                        [enableAutoCountrySelect]="true"
                                        [enablePlaceholder]="true"
                                        [customPlaceholder]="placeholder"
                                        [searchCountryFlag]="true"
                                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="CountryISO.Italy"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [separateDialCode]="true"
                                        [numberFormat]="PhoneNumberFormat.National"
                                        formControlName="phone"
                                        #itiPhoneInput
                                        #phoneInput
                                    >
                                    </ngx-intl-tel-input>
                                </form>
                            </div>
                            <div class="flex-row width-100">
                                <button mat-flat-button color="primary" (click)="cancelSMS()" *ngIf="!old2FADisabled && !loading">
                                    <span translate>B_CANCEL</span>
                                </button>
                                <button
                                    mat-flat-button
                                    color="primary"
                                    (click)="old2FADisabled ? configureSMS() : save(1, false)"
                                    *ngIf="!loading"
                                    [disabled]="
                                        !itiPhoneInput.phoneNumber ||
                                        itiPhoneInput.phoneNumber === copyOfMobilePhoneNr ||
                                        f.form.controls['phone'].invalid
                                    "
                                >
                                    <div *ngIf="old2FADisabled; else other_content">
                                        <span translate>2FA_SETTINGS.SEND_CODE </span>
                                    </div>
                                    <ng-template #other_content>
                                        <span translate>B_SAVE </span>
                                    </ng-template>
                                </button>
                                <img *ngIf="loading" src="assets/ajax-loader.gif" />
                                <div class="flex-row align-center width-50" *ngIf="smsSent">
                                    <span class="material-icons font-size-2-12rem">done</span>
                                    <div class="flex-column">
                                        <span class="font-size-smaller">{{ message_3 }}</span>
                                        <span class="font-size-smaller">{{ message_4 }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="margin-top-1-25rem width-18-75-rem" *ngIf="!loading && old2FADisabled && showSmsSection">
                            <span class="font-weight-500">{{ message_5 }}</span>
                            <mat-form-field appearance="outline">
                                <input
                                    matInput
                                    placeholder="XXXXXX"
                                    adminAutoFocus
                                    type="number"
                                    onCopy="return false"
                                    onDrag="return false"
                                    onDrop="return false"
                                    [(ngModel)]="code"
                                    required
                                    #codeInput
                                />
                            </mat-form-field>
                            <button mat-flat-button color="primary" (click)="cancelSMS()">
                                <span translate>B_CANCEL</span>
                            </button>
                            <button
                                mat-flat-button
                                color="primary"
                                [disabled]="disableSmsSaveButton === true || code.toString().length !== 6"
                                (click)="validateSMS()"
                            >
                                <span translate>B_SAVE</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-row width-7">
                <button
                    mat-mini-fab
                    color="primary"
                    aria-label="Example icon-button with a menu"
                    *ngIf="model.TwoFactorType !== 1 && !phoneNumberEnabled"
                    (click)="showSmsSection = !showSmsSection"
                >
                    <mat-icon>add</mat-icon>
                </button>
                <div *ngIf="model.TwoFactorType === 1 || phoneNumberEnabled">
                    <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon class="color-white">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" xPosition="before">
                        <button (click)="edit()" mat-menu-item *ngIf="!showSmsSection">
                            <span translate>2FA_SETTINGS.EDIT</span>
                        </button>
                        <button mat-menu-item *ngIf="model.TwoFactorType !== 1" (click)="save(1, true)">
                            <span translate>2FA_SETTINGS.SET_METHOD</span>
                        </button>
                        <button (click)="disableSMS()" mat-menu-item *ngIf="old2FADisabled">
                            <span class="color-darkred" translate>2FA_SETTINGS.DISABLE</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>
    <div class="flex-row align-center method-section" *ngIf="old2FADisabled">
        <div class="flex-row">
            <div class="flex-row width-93">
                <div class="width-3-5-rem" style="padding-left: 0.5rem">
                    <img mat-card-image src="/assets/icons8-smartphone.svg" alt="" class="width-3-5-rem" />
                </div>
                <div class="flex-column margin-left-description">
                    <div class="flex-row align-center">
                        <span class="font-weight-400 margin-right-title" translate>2FA_SETTINGS.AUTHENTICATOR_APP</span>
                        <mat-chip-list aria-label="Fish selection">
                            <mat-chip class="bgBluMagoLight" selected *ngIf="model.TwoFactorType === 4"
                                ><span class="text-chip" translate>2FA_SETTINGS.PREFERRED</span></mat-chip
                            >
                            <mat-chip class="bgGreen" selected *ngIf="model.TOTPConfigured"
                                ><span class="text-chip" translate>2FA_SETTINGS.ENABLED</span></mat-chip
                            >
                        </mat-chip-list>
                    </div>
                    <p>{{ message_6 }}</p>
                    <div *ngIf="showQrCodeSection" class="flex-column; margin-top:2.5rem">
                        <p class="font-size-smaller" [innerHtml]="message_7"></p>
                        <span class="font-size-smaller" [innerHtml]="message_9"></span>
                        <img id="barcode" [src]="image" alt="" width="212" height="212" class="margin-top-1-25rem" />

                        <div class="margin-top-1-25rem width-13-31-rem">
                            <span class="font-weight-500">{{ message_11 }}</span>
                            <mat-form-field appearance="outline">
                                <input
                                    matInput
                                    placeholder="XXXXXX"
                                    adminAutoFocus
                                    type="number"
                                    onCopy="return false"
                                    onDrag="return false"
                                    onDrop="return false"
                                    [(ngModel)]="code"
                                    required
                                    #totpCodeInput
                                />
                            </mat-form-field>
                        </div>
                        <div class="flex-row width-100">
                            <button mat-flat-button color="primary" (click)="showQrCodeSection = !showQrCodeSection; code = ''">
                                <span translate>B_CANCEL</span>
                            </button>
                            <button mat-flat-button color="primary" [disabled]="code.toString().length !== 6" (click)="validateTOTP()">
                                <span translate>B_SAVE</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-row width-7">
                <button
                    mat-mini-fab
                    color="primary"
                    aria-label="Example icon-button with a menu"
                    *ngIf="!model.TOTPConfigured"
                    (click)="showQrCodeSection = !showQrCodeSection; getImageOtp()"
                >
                    <mat-icon>add</mat-icon>
                </button>
                <div *ngIf="model.TOTPConfigured">
                    <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon class="color-white">more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" xPosition="before">
                        <button mat-menu-item *ngIf="model.TwoFactorType !== 4" (click)="save(4)">
                            <span translate>2FA_SETTINGS.SET_METHOD</span>
                        </button>
                        <button (click)="disableTOTP()" mat-menu-item>
                            <span class="color-darkred" translate>2FA_SETTINGS.DISABLE</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>
</div>
